import { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { Radio } from '@material-ui/core'
import Dialog from '@material-ui/core/Dialog'
import ListSubheader from '@material-ui/core/ListSubheader'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'

import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import { Grid } from '@material-ui/core/'
import { SocketContext } from '../../context/Socket/SocketContext.js'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'
import { ButtonSecondary } from '../ButtonSecondary'
import ButtonWithSpinner from '../ButtonWithSpinner'
import SelectInput from '../SelectInput'
import { useStyles } from './style'

// const filterOptions = createFilterOptions({
//   trim: true
// })

const TransferTicketModalCustom = ({ modalOpen, onClose, ticketid }) => {
  const history = useHistory()
  const [queues, setQueues] = useState([])
  const [queueParentIds, setQueueParentIds] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedUser, setSelectedUser] = useState('')
  const [selectedQueue, setSelectedQueue] = useState('')
  const [queueSearch, setQueueSearch] = useState('')
  const [userSearch, setUserSearch] = useState('')
  const isMounted = useRef(true)

  const socketManager = useContext(SocketContext)

  const [userStatusMap, setUserStatusMap] = useState({})

  const classes = useStyles()

  const normalizedQueueSearch = queueSearch.trim().toLowerCase()
  const normalizedUserSearch = userSearch.trim().toLowerCase()

  const filteredQueues = queues
    .filter(queue => !queue.isBot)
    .filter(queue => !queueParentIds.includes(queue.id))
    .filter(queue =>
      queue.name?.toLowerCase().includes(normalizedQueueSearch)
    )

  const filteredUsers = users.filter(user =>
    user.name?.toLowerCase().includes(normalizedUserSearch)
  )

  const preventMenuClose = e => {
    e.stopPropagation()
  }

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (modalOpen) {
      // Lógica para carregar queues e talvez um status inicial via API
      const loadInitialData = async () => {
        setLoading(true)
        try {
          const [queuesResponse, queueOptionsResponse] = await Promise.all([
            api.get('/queue', { params: { includeAll: 'true' } }),
            api.get('/queue-options')
          ])

          const queuesList = Array.isArray(queuesResponse.data)
            ? queuesResponse.data
            : []

          const queueOptions = Array.isArray(queueOptionsResponse.data)
            ? queueOptionsResponse.data
            : []

          const parentIds = Array.from(
            new Set(
              queueOptions
                .filter(option => option.forwardQueueId != null)
                .map(option => Number(option.queueId))
                .filter(Number.isFinite)
            )
          )

          const queuesNotNotify = queuesList.filter(
            queue => queue.notificationact !== true
          )
          setQueues(queuesNotNotify)
          setQueueParentIds(parentIds)

          const { data: statusData } = await api.get('/users/list')
          const newUserStatusMap = {}
          statusData.forEach(item => {
            newUserStatusMap[item.id] = item.online
          })
          setUserStatusMap(newUserStatusMap)
          setLoading(false)
        } catch (err) {
          console.log('Não foi possível carregar os status dos usuários', err)
          setLoading(false)
        }
      }
      loadInitialData()
    }
  }, [modalOpen])

  useEffect(() => {
    const socket = socketManager.GetSocket()

    const updateStatus = data => {
      const { userId, online } = data
      setUserStatusMap(prevStatus => ({
        ...prevStatus,
        [userId]: online
      }))
    }

    if (socket) {
      socket.on('userOnlineChange', updateStatus)
    }

    return () => {
      if (socket) {
        socket.off('userOnlineChange', updateStatus)
      }
    }
  }, [socketManager, modalOpen])

  useEffect(() => {
    const queue = queues.find(q => q.id === selectedQueue)
    if (queue?.users) {
      setUsers(queue.users)
      return
    }
    if (selectedQueue) {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get('/users', {
            params: { queueIds: [selectedQueue] }
          })
          setUsers(data.users)
        } catch (err) {
          toastError(err)
        }
      }
      fetchUsers()
    } else {
      setUsers([])
    }
  }, [selectedQueue, queues])

  const handleClose = () => {
    onClose()
    setSelectedUser('')
    setSelectedQueue('')
    setQueueSearch('')
    setUserSearch('')
    setQueueParentIds([])
  }

  const handleSaveTicket = async e => {
    e.preventDefault()
    if (!ticketid) return
    if (!selectedQueue || selectedQueue === '') return
    setLoading(true)
    try {
      let data = {}

      if (selectedUser) {
        data.userId = selectedUser
        data.status = 'pending'
      } else {
        data.status = 'pending'
        data.userId = null
      }

      if (selectedQueue && selectedQueue !== null) {
        data.queueId = selectedQueue
      }

      await api.put(`/tickets/${ticketid}`, data)

      history.push(`/tickets`)
    } catch (err) {
      setLoading(false)
      toastError(err)
    }
  }

  return (
    <Dialog
      open={modalOpen}
      onClose={handleClose}
      maxWidth="lg"
      scroll="paper"
      classes={{ paper: classes.dialog }}
    >
      <form onSubmit={handleSaveTicket}>
        <DialogTitle id="transferTicketModal" className={classes.dialogTitle}>
          {/* {i18n.t('transferTicketModal.title')} */}
          Transferir Atendimento
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
              <SelectInput
                value={selectedQueue}
                onChange={e => {
                  setSelectedQueue(e.target.value)
                  setSelectedUser('')
                  setUserSearch('')
                }}
                // label={i18n.t('transferTicketModal.fieldQueuePlaceholder')}
                label="Transferir para"
              >
                <ListSubheader
                  disableSticky
                  onMouseDown={preventMenuClose}
                  onClick={preventMenuClose}
                >
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    value={queueSearch}
                    placeholder="Pesquisar departamento"
                    onChange={e => setQueueSearch(e.target.value)}
                    onMouseDown={preventMenuClose}
                    onClick={preventMenuClose}
                    onKeyDown={e => e.stopPropagation()}
                  />
                </ListSubheader>
                <MenuItem value="" className={classes.menuItem}>
                  Selecione
                </MenuItem>
                {filteredQueues?.length > 0 &&
                  filteredQueues.map((queue, key) => (
                    <MenuItem
                      dense
                      key={key}
                      value={queue.id}
                      className={classes.menuItem}
                    >
                      <Radio
                        checked={queue.id === selectedQueue}
                        className={classes.radio}
                      />
                      {queue.name}
                    </MenuItem>
                  ))}
              </SelectInput>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <SelectInput
                label="Atendente"
                value={selectedUser}
                onChange={e => setSelectedUser(e.target.value)}
                multiple={false}
                disabled={!selectedQueue}
              >
                <ListSubheader
                  disableSticky
                  onMouseDown={preventMenuClose}
                  onClick={preventMenuClose}
                >
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    value={userSearch}
                    placeholder="Pesquisar atendente"
                    onChange={e => setUserSearch(e.target.value)}
                    onMouseDown={preventMenuClose}
                    onClick={preventMenuClose}
                    onKeyDown={e => e.stopPropagation()}
                    disabled={!selectedQueue}
                  />
                </ListSubheader>
                {/* <MenuItem value="" className={classes.menuItem}>
                  Disponível
                </MenuItem> */}
                <MenuItem value="" className={classes.menuItem}>
                  <Radio checked={!selectedUser} className={classes.radio} />
                  <span>Disponível</span>
                </MenuItem>
                {filteredUsers.map((user, key) => {
                  const isOnline = userStatusMap[user.id]

                  return (
                    <MenuItem
                      key={key}
                      value={user.id}
                      className={classes.menuItem}
                    >
                      <Radio
                        checked={user.id === selectedUser}
                        className={classes.radio}
                      />
                      <span>{user.name}</span>
                      <div className={classes.statusContainer}>
                        <span
                          className={
                            isOnline
                              ? classes.statusDotOnline
                              : classes.statusDotOffline
                          }
                        />
                        <span className={classes.userStatus}>
                          {isOnline ? '(On)' : '(Off)'}
                        </span>
                      </div>
                    </MenuItem>
                  )
                })}
              </SelectInput>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonSecondary
            onClick={handleClose}
            disabled={loading}
            label={i18n.t('transferTicketModal.buttons.cancel')}
          />
          <ButtonWithSpinner
            variant="contained"
            type="submit"
            color="primary"
            loading={loading}
          >
            {i18n.t('transferTicketModal.buttons.ok')}
          </ButtonWithSpinner>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default TransferTicketModalCustom